import { render, staticRenderFns } from "./AccountFormInfo.vue?vue&type=template&id=39dc6905&scoped=true&"
import script from "./AccountFormInfo.vue?vue&type=script&lang=ts&"
export * from "./AccountFormInfo.vue?vue&type=script&lang=ts&"
import style0 from "./AccountFormInfo.vue?vue&type=style&index=0&id=39dc6905&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dc6905",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
